import DefaultTh from './default-th';
import resizable from 'src/components/common/resizable';
import { appTableClsPrefix } from '../cls-prefixes';

export default resizable(DefaultTh, `${appTableClsPrefix}__resizable-wrapper`);
